// import global from "@/prototype/global.js";

import uuid from "@/library/uuid.js";

import {json_deep_clone} from "@/prototype/utils/JSON.js";

// const log = global.log.getLogger("f_mtac.scene.objects.genericjson");

const generate_object_id = () => `local-${uuid()}`;

const Generic = function(group, data) {
    if (!("id" in data)) {
        data.id = generate_object_id();
    }
    if (!("attributes" in data)) {
        data.attributes = {};
    }
    data.type = "json";
    group[data.id] = data.attributes;
    delete data.attributes;
    Object.defineProperties(this, {
        id: {
            set: () => {},
            get: () => data.id
        },
        layer_name: {
            set: () => {},
            get: () => data.layer_name
        },
        handle: {
            set: () => {},
            get: () => data
        },
        attributes: {
            set: () => {},
            get: () => group[data.id]
        },
        type: {
            set: () => {},
            get: () => data.type
        }
    });
    this.change_id = () => {
        data.id = generate_object_id();
    };
    this.serialize = () => {
        return {
            timestamp: Date.now(),
            attributes: json_deep_clone(group[data.id]),
            ...data
        };
    };
    this.deserialize = (new_data) => {
        if (new_data.type !== "json") {
            return;
        }
        Object.assign(group[data.id], new_data.attributes);
    };
};

export default Generic;
